
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/actuary/courses/gh101",
      function () {
        return require("private-next-pages/actuary/courses/gh101/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/actuary/courses/gh101"])
      });
    }
  